exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "nav {\n  border: 1px solid black;\n}\n\n#dropdowns {\n  margin-bottom: 10px;\n}\n\n#dropdowns a:hover {\n  background-color: rgb(0, 175, 228);\n  cursor: pointer;\n}\n\n#collections {\n  margin-top: 5px;\n}\n\n.navbar-brand {\n  margin-bottom: 10px;\n}\n\n.navbar-right {\n  margin-left: 3em;\n}\n\n.nav-item {\n  padding-left: 3em;\n  color: black;\n}\n\n@media only screen and (max-width: 518px) {\n  .navbar-right {\n    margin-left: -15px;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/structural_components/nav-bar/nav-bar.component.css
// module id = 385
// module chunks = 1